<p-toast [key]="toasterKey" [baseZIndex]="3000" class="avano-toaster">
  <ng-template #template let-message pTemplate="message" [typedTemplate]="templateTypes?.message">

    <ng-container [ngSwitch]="message.messageType">
      <ng-container *ngSwitchCase="messageTypes.feedback">
        <ng-container *ngTemplateOutlet="feedback; context: {$implicit: message}" ></ng-container>
      </ng-container>

      <ng-container *ngSwitchCase="messageTypes.notification" >
        <ng-container *ngTemplateOutlet="notification; context: {$implicit: message}" ></ng-container>
      </ng-container>

      <ng-container *ngSwitchCase="messageTypes.custom" >
        <ng-container *ngTemplateOutlet="message.messageDetails.toasterTemplate; context: {$implicit: message.messageDetails.data}" ></ng-container>
      </ng-container>
    </ng-container>
    
  </ng-template>
</p-toast>

<ng-template #feedback let-message [typedTemplate]="templateTypes?.message">
  <div class="avano-action-feedback-icon">
    <i [class]="message.icon"></i>
  </div>
  <div class="avano-action-feedback-text">
    {{message.summary}}
  </div>
</ng-template>

<ng-template #notification let-message [typedTemplate]="templateTypes?.message">
  <div class="avano-notification-caption">
    {{message.summary}}
  </div>
  <div class="avano-notification-container">
    <div class="avano-notification-icon">
      <i [class]="message.icon"></i>
    </div>
    <div class="avano-notification-description">
      <div class="avano-notification-description-text">
        {{ message.detail }}
      </div>
      <div class="avano-notification-description-buttons" *ngIf="message.data?.detailsButton">
        <button avanoButton label="Cancel"></button>
        <button avanoButton [label]="message.data?.detailsButton.label" [callToAction]="true" [icon]="message.data?.detailsButton.icon" (click)="message.data?.detailsButton.action()"></button>
      </div>
    </div>
  </div>
</ng-template>